export {
  DeckPrimaryActionButton,
  DeckPrimaryActionButtonProps,
} from './DeckPrimaryActionButton';
